import type { ReactNode } from 'react'
import { View, StyleSheet, ActivityIndicator } from 'react-native'

import { DS } from '@/design-system'
import { Title } from '../../components/ANewDesign/Title'
import { LeaderboardList, LeaderboardPlayer } from '../../components/ANewDesign/LeaderboardList/LeaderboardList'
import { LeaderboardInformation } from '../../components/ANewDesign/LeaderboardInformation/LeaderboardInformation'
import { color } from '../../theme'
import { WebWrapper } from '@/components/WebWrapper'

interface LeaderBoardViewProps {
  loading: boolean
  title: string
  onClose: () => void
  paddingTop: number
  players: ReadonlyArray<LeaderboardPlayer>
  myPlayerId: string | undefined
  myRank: number
  runTime: string
  prizePool: number
  details?: ReactNode
  footer?: ReactNode
}

export const LeaderBoardView = ({
  loading,
  title,
  onClose,
  paddingTop,
  players,
  myPlayerId,
  myRank,
  runTime,
  prizePool,
  details,
  footer
}: LeaderBoardViewProps) => {
  return (
    <DS.Frame style={[styles.container, { paddingTop }]}>
      <WebWrapper>
        <DS.Frame style={styles.separator}>
          <Title title={title} onClose={onClose} />
        </DS.Frame>

        {loading ? (
          <View style={styles.loadingContainer}>
            <ActivityIndicator />
          </View>
        ) : (
          <>
            <LeaderboardInformation myRank={myRank} numEntries={players?.length} runTime={runTime} prizePool={prizePool} />
            {details}
            <LeaderboardList players={players} myPlayerId={myPlayerId} />
            {footer}
          </>
        )}
      </WebWrapper>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.palette.green
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  separator: {
    borderBottomColor: 'rgba(255, 255, 255, 0.2)',
    borderBottomWidth: 1
  }
})
